<div *ngIf="!posterLoadingFailed" (click)="play()" class="ziggeo-player-container">
  <div *ngIf="!playing || !canPlay" class="poster-container">
    <img [src]="posterUrl" (error)="onPosterLoadError()" class="poster" />
    <div class="playbutton-container">
      <div *ngIf="!playing" class="playbutton"></div>
      <rt-spinner *ngIf="playing && !canPlay" layout-centered> </rt-spinner>
    </div>
  </div>
  <video
    *ngIf="playing && !posterLoadingFailed"
    (canplay)="onCanPlay()"
    width="100%"
    height="auto"
    controls
    controlsList="nodownload"
    autoplay
    [class.video-hidden]="!canPlay"
  >
    <source [src]="videoUrl + '.mp4'" type="video/mp4" />
    <source [src]="videoUrl + '.ogg'" type="video/ogg" />
  </video>
</div>
<div class="error-message" *ngIf="posterLoadingFailed">
  {{ noAnswer }}
</div>
